import {
    FETCH_MOVIE_REQUEST,
    FETCH_MOVIES_REQUEST,
    FETCH_MOVIE_SUCCESS,
    FETCH_MOVIES_SUCCESS,
    MOVIE_RESET,
    PREPARE_QUERY_STRING,
    UPDATE_QUERY_STRING,
    MOVIE_ADDED_TO_FAVORITES,
    MOVIE_DELETED_FROM_FAVORITES,
    PREMIERE_ADDED_TO_FAVORITES,
    PREMIERE_DELETED_FROM_FAVORITES,
    FETCH_FAVORITES_MOVIES_SUCCESS,
    FAVORITES_MOVIES_RESET,
    UPDATE_SEARCH_FILTER,
    CLEAR_SEARCH_FILTER,
    FETCH_MOVIE_FAILURE,
    FETCH_MOVIES_FAILURE,
    FETCH_FAVORITES_BY_ID_FAILURE,
    SELECTIVELY_CLEAR_QUERY_STRING,
} from './types';

function prepareQueryString(query) {
    const preparedQueryString = {
        genre: [],
        country: [],
        year: [],
        page: ['1'],
    };

    for (let prop in query) {
        if (prop !== 'type') {
            if (Array.isArray(query[prop])) {
                preparedQueryString[prop] = [...query[prop]];
            } else {
                preparedQueryString[prop] = [query[prop]];
            }
        }
    }

    return preparedQueryString;
}

function updateQueryString(state, event) {
    if (!state.queryString[event.target.dataset.myfilter].includes(event.target.name)) {
        return {
            ...state.queryString,
            page: ['1'],
            [event.target.dataset.myfilter]: [...state.queryString[event.target.dataset.myfilter], event.target.name]
        };
    } else if (state.queryString[event.target.dataset.myfilter].includes(event.target.name)) {
        return {
            ...state.queryString,
            page: ['1'],
            [event.target.dataset.myfilter]: state.queryString[event.target.dataset.myfilter].filter((filterName) => filterName !== event.target.name),
        }
    }
}

function selectivelyClearQueryString(state, event) {
    return {
        ...state.queryString,
        page: ['1'],
        [event.target.dataset.clearfilter]: [],
    };
}

export function reducer(state, {type, payload}) {
    switch (type) {
        case FETCH_MOVIE_REQUEST:
            return  {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_MOVIES_REQUEST:
            return  {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_MOVIE_SUCCESS:
            return  {
                ...state,
                movie: {...payload.movie},
                loading: false,
                error: null,
            };

        case FETCH_MOVIES_SUCCESS:
            return  {
                ...state,
                movies: [...payload.movies],
                lastType: payload.type,
                loading: false,
                error: null,
            };

        case MOVIE_RESET:
            return  {
                ...state,
                movie: {},
            };

        case PREPARE_QUERY_STRING:
            return {
                ...state,
                queryString: prepareQueryString(payload.query),
                start: false,
            };

        case UPDATE_QUERY_STRING:
            return {
                ...state,
                queryString: updateQueryString(state, payload.event),
            };

        case MOVIE_ADDED_TO_FAVORITES:
            return {
              ...state,
                favoritesMoviesId: [...state.favoritesMoviesId, payload.id],
            };

        case MOVIE_DELETED_FROM_FAVORITES:
            const filteredFavoritesMoviesId = state.favoritesMoviesId.filter((id) => id !== payload.id);

            return {
                ...state,
                favoritesMoviesId: filteredFavoritesMoviesId,
            };

        case PREMIERE_ADDED_TO_FAVORITES:
            return {
                ...state,
                favoritesPremieresId: [...state.favoritesPremieresId, payload.id],
            };

        case PREMIERE_DELETED_FROM_FAVORITES:
            const filteredFavoritesPremieresId = state.favoritesPremieresId.filter((id) => id !== payload.id);

            return {
                ...state,
                favoritesPremieresId: filteredFavoritesPremieresId,
            };

        case FETCH_FAVORITES_MOVIES_SUCCESS:
            return {
                ...state,
                favoritesMovies: [...payload.favoritesMovies],
                favoritesPremieres: [...payload.favoritesPremieres],
                loading: false,
                error: null,
            };

        case FAVORITES_MOVIES_RESET:
            return {
              ...state,
                favoritesMovies: [],
                favoritesPremieres: [],
            };

        case UPDATE_SEARCH_FILTER:
            return {
                ...state,
                searchFilter: payload.filter.toLowerCase(),
                queryString: {
                    ...state.queryString,
                    page: ['1'],
                },
            };

        case CLEAR_SEARCH_FILTER:
            return {
                ...state,
                searchFilter: '',
            };

        case FETCH_MOVIE_FAILURE:
            return {
                ...state,
                movie: {},
                loading: false,
                error: payload.error,
            };

        case FETCH_MOVIES_FAILURE:
            return {
                ...state,
                movies: [],
                loading: false,
                error: payload.error,
            };

        case FETCH_FAVORITES_BY_ID_FAILURE:
            return {
                ...state,
                favoritesMovies: [],
                favoritesPremieres: [],
                loading: false,
                error: payload.error,
            };

        case SELECTIVELY_CLEAR_QUERY_STRING:
            return {
                ...state,
                queryString: selectivelyClearQueryString(state, payload.event),
            };

        default:
            return state;
    }
};